import { FC, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import { Button, List } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import { getRolesApi } from '@/api/user'
import { PageLoading } from '@/components/PageLoading'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { withAuth } from '@/hoc/withAuth'
import { isEmpty, getUrlParam } from '@/utils'

export const SelectRole: FC = withAuth(props => {
  const { t } = useTranslation();
  const [roles, setRoles] = useState([]);
  const dispatch = useStoreDispatch();
  const { pageLoading, inner, user }: any = useStoreState()
  const navigate = useNavigate();
  const redirectUri = getUrlParam('redirectUri')
  const gameCode = getUrlParam('gameCode')

  useEffect(() => {
    dispatch({ type: actionTypes.SET_LOGIN_MODAL_CONFIG, payload: { showCloseButton: false } });
  }, []);

  useEffect(() => {
    const getRoles = async () => {
      dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true })
      const res = await getRolesApi({ gameCode }).finally(() => dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: false }))
      if (res?.code === 0) {
        setRoles(res.data);
      }
    }
    user.isLogin && getRoles();
  }, [user.isLogin]);


  // 点击进入按钮 需要缓存选择的游戏信息 因为个人中心需要展示
  // 因为切换游戏需要加载对应的客服中心配置 而该配置放在了Layout 所以这里刷新页面进入初始化来加载
  const onBtnClick = (role: any = {}) => {
    dispatch({ type: actionTypes.SET_ROLE, payload: role });
    isEmpty(role) ? localStorage.removeItem('role') : localStorage.setItem('role', JSON.stringify(role));

    /* 判断是否有重定向 */
    if (redirectUri) {
      return window.location.href = redirectUri
    }

    const query = inner.isFrom ? `?type=${inner.type}&kfId=${inner.kfId}` : ''
    navigate(`/${role.gameCode ?? ''}${query}`);
    dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true });
    setTimeout(() => {
      location.reload();
    }, 0)
  }

  if (pageLoading) return <PageLoading />

  return (
    <div className={css.Page}>
      <RoleList roles={roles} onBtnClick={onBtnClick} />
      {/* {(roles.length === 0 && process.env.REACT_APP_IDN_ENV === 'hw') && <div className={css.tips} dangerouslySetInnerHTML={{ __html: t('user-center.select-role.tips') }}></div>} */}
      {/* {process.env.REACT_APP_IDN_ENV !== 'hw' && <div className={css.tips1}><Button color={'primary'} fill={'none'} onClick={() => onBtnClick()}>{t('user-center.select-role.tips1')}{'>>'}</Button></div>} */}
      {<div className={css.tips1}><Button color={'primary'} fill={'none'} onClick={() => onBtnClick()}>{t('user-center.select-role.tips1')}{'>>'}</Button></div>}
    </div>
  )
})


// 角色列表
export const RoleList: FC<{
  roles: any[],
  onBtnClick(role: any): void,
}> = ({ roles, onBtnClick }) => {
  const { t } = useTranslation();
  return (
    <List className={css.List}>
      {roles.map(role => (
        <List.Item
          className={css.ListItem}
          key={role.roleId}
          extra={
            <Button className={css.BtnSelect} color='primary' fill='outline' onClick={() => onBtnClick(role)}>{t('user-center.select-role.entry')}</Button>
          }
          description={
            <div className={css.Desc}>
              <div className={css.tit}>{role.gameName}</div>
              <div className={css.des}>
                <span className={css.ServerId}>{role.serverId}</span><span className={css.RoleName}>{role.roleName}</span>
              </div>
            </div>
          }
        >
          {/*{role.gameName}*/}
        </List.Item>
      ))}
    </List>

  )
}
